export default __webpack_public_path__ + "static/media/PM.1909e4d3.svg";